module.exports = __webpack_public_path__ + "img/sns_Instagram.2a6a17bb.png";